import type { Locale } from "./types";

const messages = {
  en: {
    title: "OpenCal Bridge",
    subtitle: "Offline CSV/XLSX → PTB DCC 3.3.0",
    privacy: "Your calibration data stays in this browser. No upload, account, or API key.",
    choose: "Choose CSV or XLSX",
    sample: "Load synthetic sample",
    empty: "Load a file to start the audit pipeline.",
    input: "Input checks",
    semantic: "Metrology semantics",
    xsd: "PTB DCC 3.3.0 XSD",
    notRun: "Not run",
    passed: "Passed",
    failed: "Failed",
    warnings: "warning(s)",
    exportXml: "Download DCC XML",
    exportReport: "Download audit report",
    schemaNote: "XSD-valid means structurally valid only. Metrological compliance is NOT ASSESSED.",
    preview: "Measurement preview",
    error: "Error",
    uncertainty: "Expanded uncertainty",
    reference: "Reference",
    indication: "Indication",
    certificate: "Certificate",
    item: "Item",
    rows: "Rows",
    diagnostics: "Diagnostics",
  },
  "zh-CN": {
    title: "OpenCal Bridge",
    subtitle: "离线 CSV/XLSX → PTB DCC 3.3.0",
    privacy: "校准数据只在当前浏览器处理，不上传、无需账号或 API Key。",
    choose: "选择 CSV 或 XLSX",
    sample: "载入合成示例",
    empty: "请载入文件，开始可审计转换。",
    input: "输入检查",
    semantic: "计量语义检查",
    xsd: "PTB DCC 3.3.0 XSD",
    notRun: "尚未运行",
    passed: "通过",
    failed: "未通过",
    warnings: "条警告",
    exportXml: "下载 DCC XML",
    exportReport: "下载审计报告",
    schemaNote: "XSD 通过仅代表结构有效；计量合规性：未评估。",
    preview: "测量结果预览",
    error: "误差",
    uncertainty: "扩展不确定度",
    reference: "参考值",
    indication: "示值",
    certificate: "证书编号",
    item: "被校对象",
    rows: "数据行",
    diagnostics: "诊断信息",
  },
} as const;

export type MessageKey = keyof (typeof messages)["en"];
export const t = (locale: Locale, key: MessageKey): string => messages[locale][key];
